import PlatformSettingsService from '@/services/PlatformSettingsService';

type FeatureFlagsState = {
  enabledFeatures: string[];
};

export default {
  namespaced: true,
  state: {
    enabledFeatures: [],
  } as FeatureFlagsState,
  mutations: {
    setEnabledFeatures(state: FeatureFlagsState, enabledFeatures: string[]) {
      state.enabledFeatures = enabledFeatures;
    },
  },
  actions: {
    async getAllEnabledFeatures({ commit }: { commit: (type: string, payload?: unknown) => void }) {
      const { data: { enabledFeatures } } = await PlatformSettingsService.getFeatureFlags();
      commit('setEnabledFeatures', enabledFeatures);
    },
  },
  getters: {
    getEnabledFeatures: (state: FeatureFlagsState) => state.enabledFeatures,
  },
};
